<div id="cl-wrapper" class="login-container login-theme padding-50">
  <div class="block-flat" *ngIf="message.length === 0">
    <div class="header">
      <h3>
        {{'PROCESSING' | translate}}
        <i class="fas fa-spinner fa-pulse fa-fw"></i>
      </h3>
    </div>
  </div>

  <div class="block-flat" *ngIf="message.length > 0">
    <div [class]="title === 'SUCCESS' ? 'header service-success' : 'header service-error'">
      <h3>
        <i [class]="title === 'SUCCESS' ? 'fas fa-check-circle' : 'fas fa-times-circle'"></i>
        {{title | translate}}
      </h3>
    </div>
    <div>
      <div class="form-horizontal">
        <div class="content">
          <div class="panel panel-default">
            <div class="panel-body">
              <div class="form-group no-margin-bottom">
                <h5 class="color-default">
                  {{message | translate}}
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div class="foot">
          <a class="btn btn-primary" title="{{'BACK_TO_PORTAL' | translate}}" [routerLink]="['/']">
            <i class="fas fa-arrow-left"></i>&nbsp;{{'BACK_TO_PORTAL' | translate}}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>